import {PageState,DateRange,PublisherOrSiteOption,ProductRecord,CampaignRecord, CLinkOwnerOption, QueryFlags} from "../utils/types";
import {PublisherSiteRecord,PlacementRecord,IdName,TrafficSourceResponseDto} from "../utils/types";

import COUNTRIES from "../components/countries";
import StateHelper from "../utils/StateHelper";
import {getGroupByArray} from "../utils/misc";
import {TRAFFIC_TYPES_ARRAY} from "../utils/misc";
import { PagesHelper } from "./PagesHelper";
import dayjs from "../utils/dayjs";

function extractPlacement( pId : string, trafficSourceResponseDto: TrafficSourceResponseDto) : PlacementRecord {
  const placementBreackdownArray = pId.split(":");
 
  if( placementBreackdownArray.length === 0){
    return null;
  }

  const apptapPublisherId = placementBreackdownArray[0] ? placementBreackdownArray[0] : "***";
  let apptapSiteId : string = null;
  let publisherPlacementId : string = null;
  let publisherPlacementName : string = null;
  if( placementBreackdownArray.length > 1 ){
    apptapSiteId = placementBreackdownArray[1] ? placementBreackdownArray[1] : "***";
  }
  else{
    apptapSiteId = "***";
  }

  if( placementBreackdownArray.length > 2 ){
    publisherPlacementId = placementBreackdownArray[2] ? placementBreackdownArray[2] : "***";
  }
  else{
    publisherPlacementId = "***";
  }

  const record : PlacementRecord = {
    apptapPublisherId: apptapPublisherId,
    apptapSiteId: apptapSiteId,
    publisherPlacementId: publisherPlacementId,
    publisherPlacementName: null
  }


  if( trafficSourceResponseDto && trafficSourceResponseDto.publishersArray ){


    const keyToSearch = apptapSiteId !== "***" ? apptapPublisherId + ":" + apptapSiteId : apptapPublisherId;

    const relatedPublishers : PublisherOrSiteOption[] = trafficSourceResponseDto.publishersArray.filter(function(p : PublisherOrSiteOption){
          return p.key === keyToSearch;
      });

      // get publisher/site name (if possible)
    if( relatedPublishers.length > 0){
        //publisher and site found, we have names
        const record : PublisherSiteRecord = (relatedPublishers[0].record as PublisherSiteRecord);  

        publisherPlacementName = publisherPlacementId + " - " + record.apptapPublisherName;
        
        if ( record.apptapPublisherSiteName ){
          publisherPlacementName += " - " + record.apptapPublisherSiteName + " (" + record.apptapPublisherId + ":" + record.apptapSiteId + ")";
        }
        else {
          publisherPlacementName +=  " (" + record.apptapPublisherId + ":***)"  ;
        }
    }  
    else{
        //not found, we don't have names, let's use ids.
        publisherPlacementName = publisherPlacementId + " - " + apptapPublisherId + " (" + apptapPublisherId + ":" + apptapSiteId + ")"  ;
    }
    record.publisherPlacementName = publisherPlacementName;
  }
  else {
    record.publisherPlacementName = pId;
  }
  return record;
}

/**
 * This class is the one responsible to transform fron string and basic types
 * to specific objects that will be handled by Dropdowns.
 */
export const FiltersInitialStateHelper = {

  getDateRangeState : function() : DateRange{
    const pageState : PageState = StateHelper.getPageState();
    const dateRange : DateRange = {
      dateStart : null,
      dateEnd :  null
    };

    dateRange.dateStart = pageState.dateStart ? pageState.dateStart : dayjs.utc();
    dateRange.dateEnd = pageState.dateEnd ? pageState.dateEnd : dayjs.utc();

    return dateRange;
  },

  getTrafficTypesState : function() : any[] {
    const pageState : PageState = StateHelper.getPageState();
    const defaultSelected : any[] = [];

    const trafficTypesArray = pageState.trafficTypes ? pageState.trafficTypes.split(",") : [];

    for (let i = 0; i < trafficTypesArray.length; i++) {
      const id = trafficTypesArray[i];
      for (let x = 0; x < TRAFFIC_TYPES_ARRAY.length; x++) {
        const element = TRAFFIC_TYPES_ARRAY[x];
        if (id === element.id){
          defaultSelected.push(element);
        }
      }
    }
    return defaultSelected;
  },

  getGroupByState : function(page :string,allowedGroupByFields : string[]) : any[] {
    const pageState : PageState = StateHelper.getPageState();
    const groupByReturned : IdName[] = [];
    const GROUP_BY_ARRAY = getGroupByArray(page,allowedGroupByFields);
    const groupByArray = pageState.groupBy ? pageState.groupBy.split(",") : [];

    for (let i = 0; i < groupByArray.length; i++) {
      const id = groupByArray[i];
      for (let x = 0; x < GROUP_BY_ARRAY.length; x++) {
        const element = GROUP_BY_ARRAY[x];
        if (id === element.id){
          groupByReturned.push(element);
        }
      }
    }

    return groupByReturned;
  },

  getCountriesState : function() : any[] {
    const baseState : PageState = StateHelper.getPageState();
    const defaultSelected : any[] = [];
    const countryIdsArray = baseState.countries ? baseState.countries.split(",") : [];

    for (let i = 0; i < countryIdsArray.length; i++) {
      const id = countryIdsArray[i];
      for (let x = 0; x < COUNTRIES.length; x++) {
        const element = COUNTRIES[x];
        if (id === element.id){
          defaultSelected.push(element);
        }
      }
    }
    return defaultSelected;
  },

  getTrafficSourceState : function(publishersArray : PublisherOrSiteOption[]) : PublisherOrSiteOption[] {
    const pageState : PageState = StateHelper.getPageState();
    const defaultSelected : PublisherOrSiteOption[] = [];
    const publisherIdsArray = pageState.publishers ? pageState.publishers : [];

    for (let i = 0; i < publisherIdsArray.length; i++) {
      const publisherAndSite = publisherIdsArray[i];
      let found : boolean = false;

      for (let x = 0; x < publishersArray.length; x++) {
        const publisher = publishersArray[x];
        if (publisherAndSite === publisher.key){
          found = true;
          defaultSelected.push(publisher);
        }
      }
      if (!found) {
        //traffic source not found in response.
        const breakDown : string[] = publisherAndSite.split(":");
        const publisherId : string = breakDown[0] ? breakDown[0] : "***";
        const siteId : string = breakDown.length > 1 && breakDown[1] ? breakDown[1] : "***";
        const publisherName : string = publisherId === "***" ? "<All Publishers>" : publisherId;

        const newElement : PublisherOrSiteOption = {
          record : {
              apptapSiteId: siteId,
              apptapPublisherSiteName: siteId,
              apptapPublisherId: publisherId,
              apptapPublisherName: publisherName,
              retired: false,
              active: true
          },
          key: publisherAndSite,
          id: publisherAndSite,
          text: publisherAndSite
        };
        defaultSelected.push(newElement);
      }
    }
    return defaultSelected;
  },

  getCampaignsState : function(campaignsResponse : CampaignRecord[]) : CampaignRecord[] {
    const pageState : PageState = StateHelper.getPageState();
    const selected : CampaignRecord[] = [];
    const campaignIdsArray = pageState.campaigns === null || pageState.campaigns === undefined ? [] : pageState.campaigns;

    for (let i = 0; i < campaignIdsArray.length; i++) {
      const id = campaignIdsArray[i];
      let campaign:CampaignRecord = campaignsResponse.find((campaign) => PagesHelper.getCampaignSourceAliasAndID(campaign) === id);
      if (!campaign) {
        const campaignSourceAlias = id.includes(":") ? id.split(":")[0] : id;
        const campaignId = id.includes(":") ? id.split(":")[1] : "***";

        campaign = { id, name: id, labelKey:id, productId: id, campaignId,  campaignSourceAlias, campaignSource: "", campaignStatus: null };
      }
      selected.push(campaign);
    }

    return selected;
  },
    
  getProductsState : function(productsResponse : ProductRecord[]) : ProductRecord[] {
    const pageState : PageState = StateHelper.getPageState();
    const selected : ProductRecord[] = [];
    const productIdsArray : string[] = pageState.productIds ? pageState.productIds.split(",") : [];

    for (let i = 0; i < productIdsArray.length; i++) {
      const id = productIdsArray[i];
      let publisher:ProductRecord = productsResponse.find((product) => product.id === id);
      if (!publisher) publisher = { id, name: id, productId: id, productName: id, icon: "", productPlatform: "" };
      selected.push(publisher);
    }
    return selected;
  },

  getPublisherPlacementsInitialState : function(trafficSourceResponseDto: TrafficSourceResponseDto) : PlacementRecord[] {
    const pageState : PageState = StateHelper.getPageState();
    const publisherPlacementsArray : PlacementRecord[] = [];
    const publisherPlacementIdsArray = pageState.placements ? pageState.placements : [];

    for (let i = 0; i < publisherPlacementIdsArray.length; i++) {
      const pId = publisherPlacementIdsArray[i];
      const placement = extractPlacement(pId, trafficSourceResponseDto);
      publisherPlacementsArray.push(placement);
    }
    return publisherPlacementsArray;
  },

  getCLinkOwnersState : function(page :string, cLinksResponse : CLinkOwnerOption[]) : CLinkOwnerOption[] {
    const pageState : PageState = StateHelper.getPageState();
    const selected : CLinkOwnerOption[] = [];
    const cLinksIdsArray : string[] =  pageState.cLinks ? pageState.cLinks : [];

    cLinksIdsArray.forEach((cLinkOption : string) => {
      let cLink : CLinkOwnerOption = cLinksResponse.find((cLink : CLinkOwnerOption) => cLinkOption === PagesHelper.fromCLinkOwnerOptionToString(cLink));
      if (!cLink) {
        cLink = {
          id: cLinkOption,
          key: cLinkOption,
          record: cLinkOption,
          text: ""
        }
      }
      selected.push(cLink);
    });

    return selected;
  },

  getQueryFlagsState : function() : any[] {
    const pageState : PageState = StateHelper.getPageState();
    const defaultSelected : any[] = [];

    const queryFlagsArray = pageState.queryFlags ? pageState.queryFlags : [];

    for (let i = 0; i < queryFlagsArray.length; i++) {
      const queryFlag = queryFlagsArray[i];
      for (let x = 0; x < Object.values(QueryFlags).length; x++) {
        const element = Object.values(QueryFlags)[x];
        if (queryFlag === element){
          defaultSelected.push(element);
        }
      }
    }
    return defaultSelected;
  }
};